import { homeRoute } from './../../core/routing/route-names';
import { OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordDTO, UserAccountClient } from '../models/models.swagger.generated';
import { ToastService } from '../services/toast.service';
import { passwordValidation } from '../directives/password-validation.directive';
import { TranslateModule } from '@ngx-translate/core';

import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { PasswordVisibilityDirective } from '../directives/password-visibility.directive';
import { MarkAsteriskDirective } from '../directives/mark-asterisk.directive';

export type ChangePasswordFormType = FormGroup<{
    oldPassword: FormControl<string>;
    newPassword: FormControl<string>;
    newPasswordConfirm: FormControl<string>;
  }>;

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    imports: [ReactiveFormsModule, MarkAsteriskDirective, PasswordVisibilityDirective, AppErrorMessagesComponent, TranslateModule]
})
export class ChangePasswordComponent implements OnInit {
  public loading = false;
  public changePasswordForm: ChangePasswordFormType;
  public oldPasswordControl: FormControl<string>;
  public newPasswordControl: FormControl<string>;
  public newPasswordConfirmControl: FormControl;
  private changePasswordDTO: ChangePasswordDTO;

  constructor(
    private router: Router,
    private userAccountClient: UserAccountClient,
    private toastService: ToastService) {
  }

  ngOnInit() {
    this.initializeForm();
  }

  hasValidPasswords(group: ChangePasswordFormType): boolean {
    const pass = group.value.newPassword;
    const confirmPass = group.value.newPasswordConfirm;

    if (pass !== confirmPass) {
      this.loading = false;
      this.toastService.showError(
        'i18n.core.messages.changePassword.title',
        'i18n.core.messages.changePassword.pwdDoNotMatch');
      return false;
    }

    return true;
  }

  public changePassword(): void {
    this.loading = true;

    this.changePasswordDTO = new ChangePasswordDTO();
    this.changePasswordDTO.oldPassword = this.changePasswordForm.value.oldPassword;
    this.changePasswordDTO.newPassword = this.changePasswordForm.value.newPassword;

    if (!this.hasValidPasswords(this.changePasswordForm)) {
      return;
    }

    // if (this.changePasswordDTO.newPassword != this.newPasswordConfirm){
    // if (!this.checkPasswords(this.changePasswordForm)) {
    //   this.loading = false;

    //   this.toastService.showError(
    //     'i18n.core.messages.changePassword.title',
    //     'i18n.core.messages.changePassword.pwdDoNotMatch');
    //     return;
    // }


    this.userAccountClient.changePassword(this.changePasswordDTO).subscribe({
      next: (result) => {
        this.loading = false;

        if (result) {
          this.router.navigate([homeRoute]);
        }
      },
      error: error => {
        this.loading = false;

        this.toastService.showApiException(error,
          'i18n.core.messages.changePassword.title',
          'i18n.core.messages.changePassword.message');
      }}
    );
  }

  private initializeForm(): void {
    this.oldPasswordControl = new FormControl('', [Validators.required]);
    this.newPasswordControl = new FormControl('', [Validators.required, passwordValidation()]);
    this.newPasswordConfirmControl = new FormControl('', [Validators.required, passwordValidation()]);
    this.changePasswordForm = new FormGroup({
      oldPassword: this.oldPasswordControl,
      newPassword: this.newPasswordControl,
      newPasswordConfirm: this.newPasswordConfirmControl
    });
  }
}
